import React, { useCallback, useState, useRef, useEffect } from 'react';
import { translate } from '@shakkerai/util-i18n';
import { ImageWindowWrapper } from '../base/Wrapper';
import { ImageKey, usePartialState } from '../../store/state';
import FilterPic from './FilterPic';
import { loadImagesByPrompt } from '../../store/actions';
import { ImageList } from '../base/List';
import { Icon } from '@shakkerai/components';

const sortOptions = [
  { value: 'case', label: translate('imakgegallery_title_rec') },
  { value: 'more', label: translate('Modelgallery_title_top') },
];

export const ImagesWindow = React.memo(() => {
  const recommendData = usePartialState('recommendImages.data');
  const hotData = usePartialState('hotImages.data');
  const allData = usePartialState('allImages.data');
  const initFlag = useRef(null);
  const [filters, setFilters] = useState({
    flag: false, // 这个开关由回车键(true)和input清除键(false)来控制
    keyword: '',
    sortType: recommendData.items.length > 0 ? 'case' : undefined,
  });

  useEffect(() => {
    initFlag.current = recommendData.items.length > 0;
    setFilters({
      ...filters,
      sortType: initFlag.current ? 'case' : undefined,
    });
    if (recommendData.items.length) {
      loadImagesByPrompt('', ImageKey.hotImages, true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recommendData.items]);

  const caseImagesWrapperRef = useRef(null);
  const listWrapperRef = useRef(null);

  const handleScroll = useCallback(
    (event) => {
      const { scrollTop } = event.currentTarget;
      // 判断推荐图片是否滚动到了顶部
      const caseImagesHeight = caseImagesWrapperRef.current.clientHeight;
      setFilters({
        ...filters,
        sortType: scrollTop >= caseImagesHeight - 10 ? 'more' : 'case',
      });
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    [filters],
  );

  useEffect(() => {
    if (!initFlag.current) {
      // 没有prompt拿all数据
      loadImagesByPrompt('', ImageKey.allImages, true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleApplyFilter = async ({ keyword, sortType }) => {
    if (!sortType) {
      await loadImagesByPrompt(keyword, ImageKey.allImages);
      const dom = listWrapperRef.current;
      dom && dom.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    } else {
      if (sortType === 'case' && recommendData.items.length === 0) {
        await loadImagesByPrompt('', ImageKey.recommendImages, true);
      }
      if (sortType === 'more' && hotData.items.length === 0) {
        await loadImagesByPrompt('', ImageKey.hotImages, true);
      }
    }
    setTimeout(() => {
      const dom = listWrapperRef.current;
      if (sortType === 'more') {
        dom && dom.scrollTo({ top: caseImagesWrapperRef.current.clientHeight, behavior: 'smooth' });
      }
      if (sortType === 'case') {
        dom && dom.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }, 0);
  };
  const AllDataContent = () => {
    if (allData.loading) {
      return (
        <div className="flex items-center justify-center mt-12 text-xs text-[#7f7f7f]">{translate('loading')}...</div>
      );
    }
    if (allData.items.length === 0) {
      return (
        <div className="flex flex-col items-center mt-24">
          <Icon className="shk-danchuang-gengduomoxing1" fontSize={32} color="#D7D7D7" />
          <span className="mt-4 text-xs text-[#adadad]">{translate('gallery_no_more')}</span>
        </div>
      );
    } else {
      return (
        <div ref={listWrapperRef} className="flex-1 overflow-auto tiny-scrollbar px-4 pb-2">
          <div className="mb-2">
            <ImageList data={allData} withNormalLayout={false} isModelImage showFooter={false} />
          </div>
        </div>
      );
    }
  };
  return (
    <ImageWindowWrapper type="images" label={translate('gallery_title')}>
      <div className="flex flex-col items-stretch flex-1 overflow-hidden">
        <div className="mt-2 mb-2">
          <FilterPic
            initFlag={initFlag.current}
            filters={filters}
            setFilters={setFilters}
            sortOptions={sortOptions}
            onSubmit={handleApplyFilter}
          />
        </div>
        {typeof filters.sortType === 'undefined' ? (
          AllDataContent()
        ) : (
          <div ref={listWrapperRef} onScroll={handleScroll} className="flex-1 overflow-auto tiny-scrollbar px-4 pb-2">
            <div ref={caseImagesWrapperRef} className="mb-2">
              <ImageList data={recommendData} withNormalLayout={false} isModelImage showFooter={false} />
            </div>
            {hotData.items.length && recommendData.items.length ? (
              <div className="flex items-center justify-center mt-5 mb-3">
                <div className="w-16 h-px bg-[#efefef]" />
                <span className="mx-3 text-[#2D2D2D] text-xs">{translate('Modelgallery_title_top')}</span>
                <div className="w-16 h-px bg-[#efefef]" />
              </div>
            ) : null}
            <ImageList data={hotData} isModelImage showFooter={true} />
          </div>
        )}
      </div>
    </ImageWindowWrapper>
  );
});
